export default {
  titles: {
    main: 'We can’t accept more online orders.',
    opens_today: 'Online orders are currently paused. You can order again online at {{time}}.',
    opens_other_day: 'Online orders are currently paused. You can order again online on {{dateTime}}.'
  },
  pay_remaining: 'Please pay remaining bill here.',
  description: 'Online orders are not available now. Please contact your server if you have any questions.',
};